import React from 'react';
import Tabs from '../Tabs/Tabs';
import ReservationSegmentCheckInWorkspace from './ReservationSegmentCheckInWorkspace';
import ReactPortalsRoot from '../ReactPortalsRoot/ReactPortalsRoot';
import ReservationSegmentCheckInConfirmationModal from './ReservationSegmentCheckInConfirmationModal';
import ModalWarning from '../ModalWarning/ModalWarning';
import ModalButtons from '../ModalButtons/ModalButtons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import numeral from 'numeral';

export default class ReservationSegmentCheckIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'general',
      loading: false,
      errors: [],
      note_count: null,
      room: this.props.reservation_segment.room || this.props.reservation_segment.room_group,
      incidental_taken: this.props.reservation_segment.incidental_deposit_card_id || this.props.reservation_segment.incidental_deposit.deposit_type === 'none' ? true : false,
      payment_due_amount: this.props.reservation_segment.payment_due_amount,
      guests_in_room: this.props.reservation_segment.customers,
      displayCheckInWarning: false,
      bypassCheckInWarning: false,
    };
    this.onChangeRoom = this.onChangeRoom.bind(this);
    this.onChangeRoomGroup = this.onChangeRoomGroup.bind(this);
    this.onChangeGuestInRoom = this.onChangeGuestInRoom.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.noteCount = this.noteCount.bind(this);
    this.onPaymentTaken = this.onPaymentTaken.bind(this);
    this.onClickSecondaryButton = this.onClickSecondaryButton.bind(this);
  };

  componentDidMount(){
    $(window).on('refresh_data_table.datatable', () => {
      this.onPaymentTaken();
    });
  };

  render() {
    return(
      <div className="ReservationSegmentCheckIn">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ReservationSegmentCheckInWorkspace
            {...this.state}
            incidental_deposit_due={this.props.reservation_segment.incidental_deposit_amount}
            reservation_segment={this.props.reservation_segment}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            onChangeRoom={this.onChangeRoom}
            reservation_segment_notes_path={this.props.reservation_segment_notes_path}
            reservation_segment_check_in_folios_data_table={this.props.reservation_segment_check_in_folios_data_table}
            noteCount={this.noteCount}
            onChangeGuestInRoom={this.onChangeGuestInRoom}
            formatCurrency={this.formatCurrency}
            />
        </div>
        <ModalButtons loading={this.state.loading} buttons={this.setButtons()} />
        <LoadingSpinner show={this.state.loading} />
        {
          this.state.displayCheckInWarning && this.state.errors.length == 0
            ?
            <ReactPortalsRoot
              children={[
                <ModalWarning
                  key="body"
                  title={I18n.t('check_in_warning_header')}
                  body={
                    <ReservationSegmentCheckInConfirmationModal
                      incidental_taken={this.state.incidental_taken}
                      incidental_deposit_amount={this.props.reservation_segment.incidental_deposit_amount}
                      payment_due_amount={this.state.payment_due_amount}
                      past_check_in_time={this.props.reservation_segment.past_check_in_time}
                      check_in_time_message={this.props.reservation_segment.check_in_time_message}
                      check_in_check_out_time_source={this.props.reservation_segment.check_in_check_out_time_source}
                      />
                    }
                  CancelSubmit
                  onSubmit={() => this.setState({bypassCheckInWarning: true}, ()=> this.checkIn())}
                  onCancel={() => this.setState({ displayCheckInWarning: false })}
                />,

              ]
              }
              wrapperClassNames="ModalWarningWrapper"
            />
            :
            null
        }
      </div>
    );
  };

  setButtons() {
    return [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('check_in'),
        html_attributes: this.state.room ? [] :
        [
          'disabled="true"'
        ],
        button_classes: ['primary'],
        onClick: (e) => {
          this.checkIn()
          return false;
        }
      }
    ];
  };

  tabs() {
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.activeTab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        }
      ]
    );
  };

  onChangeActiveTab(tab) {
    this.setState({
      activeTab: tab
    });
  };

  onChangeRoom(room) {
    if (room) {
      let new_room = Object.assign({}, this.state.room)
      new_room = room
      new_room.element = null
      this.setState({
        room: new_room,
      });
    };
  };

  onChangeRoomGroup(room_group) {
    if (room_group) {
      let new_room_group = Object.assign({}, this.state.room_group)
      new_room_group = room_group
      new_room_group.element = null
      this.setState({
        room_group: new_room_group,
      });
    };
  };

  onChangeGuestInRoom(guests) {
    this.setState({guests_in_room: guests});
  };

  onClickSecondaryButton(){
    this.setState({showModal: false});
  };


  noteCount(count) {
    this.setState({
      note_count: count
    });
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  onPaymentTaken(){
    this.setState({ loading: true });
    $.ajax({
      type: 'GET',
      url: `/admin/reservation_segments/${this.props.reservation_segment.id}/check_in_update`,
    }).done((data) => {
      this.setState({
        incidental_taken: data.incidental_taken,
        payment_due_amount: data.payment_due_amount,
        loading: false,
      });
    });
  };

  checkIn(){
    if ((!this.state.incidental_taken || (this.state.payment_due_amount && this.state.payment_due_amount > 0) || !this.props.reservation_segment.past_check_in_time) && !this.state.bypassCheckInWarning) {
      this.setState({ displayCheckInWarning: true});
    } else {
      this.setState({loading: true});
      $.ajax({
        type: 'POST',
        url: `/admin/reservation_segments/${this.props.reservation_segment.id}/process_check_in`,
        data: {
          reservation_segment: {
            room_id: this.state.room ? this.state.room.id : null,
            customer_ids: this.state.guests_in_room && this.state.guests_in_room.length ? this.state.guests_in_room.map(customer => customer.id) : null,
          },
        }
      }).done((data) => {
        if (data.errors && data.errors.length) {
          this.setState({errors: data.errors, loading: false});
        } else {
          if(parent && parent.refresh_data) {
            parent.refresh_data(I18n.t("checked_in"));
          };
          if(parent && parent.hide_modal) {
            parent.hide_modal();
          };
        };
      });
    };

  };

};
